<template>
	<section class="connection-error-popup">
		<div class="connection-error-popup__rewards">
			{{ translate("ui.connection_error_info") }}
		</div>
		<div class="connection-error-popup__buttons">
			<AppTextButton
				class="connection-error-popup__btn"
				:type="StatusTypes.PRIMARY"
				:text="translate('button.restart')"
				@click="refresh"
			/>
		</div>
	</section>
</template>

<script lang="ts" setup>
import AppTextButton from "@/components/AppTextButton.vue";
import { SoundService } from "@/game/SoundService";
import Communicator from "@/libs/AppCommunicatior";
import { StatusTypes } from "@/types/ui";
import { translate } from "@/utils/translate";
import { markRaw } from "vue";

const soundService = markRaw(SoundService.getInstance());
const communicator = markRaw(Communicator.getInstance());

const refresh = (): void => {
	soundService.playGenerickClick();
	communicator.relogUser();
};
</script>

<style lang="scss" scoped>
.connection-error-popup {
	padding: 1rem 0;

	&__rewards {
		@include flex-col-center;
		position: relative;
		margin: 0 0 1rem;
		padding: 0 0.75rem;
		text-align: center;
	}
	&__buttons {
		margin: 0 1rem;
		margin-bottom: 0.25rem;
		@include flex-row-center;
		gap: 0.5rem;
	}
}
</style>
